export default ["#1D3659","#4B5E78","#7B8798","#AAB0B9", "#D9D9D9","#F16568","#6bd583"]